import { useEffect, useRef } from "react";
import { useCreateLink, useLinksForGame } from "@seabrookstudios/pitch2table";
import { s2Url } from "@seabrookstudios/types";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {string} props.url
 * @param {() => void} props.onStart
 * @param {() => void} props.onComplete
 * @param {() => void} props.onError
 */
export const GameImportPlayableLink = ({ gameId, url, onStart, onComplete, onError }) => {
  const { data: links = [], isPlaceholderData, isLoading } = useLinksForGame(gameId);
  const addLink = useCreateLink(gameId);
  const hasStarted = useRef(false);

  useEffect(() => {
    if (isPlaceholderData || isLoading) {
      return;
    }

    if (links.some((link) => link.url === url)) {
      onComplete();
      return;
    }

    if (links.some((link) => link.name === "Playable Digital Version")) {
      onComplete();
      return;
    }

    if (hasStarted.current) {
      return;
    }

    hasStarted.current = true;
    onStart();

    addLink
      .mutateAsync({
        name: "Playable Digital Version",
        url: s2Url(url),
      })
      .then(() => {
        onComplete();
      })
      .catch(() => {
        onError();
      });
  }, [isLoading, links, url, addLink, onStart, onComplete, onError]);

  return null;
};
